import { ValueColumnHeader, ValueCell, SelectRowCell, SelectColumnHeader, } from '../components';
import { SELECT_COLUMN_ID } from '../constants';
var selectionColumn = {
    id: SELECT_COLUMN_ID,
    type: 'row-selection',
    Header: SelectColumnHeader,
    Cell: SelectRowCell,
};
export var generateHeader = function (data) {
    var header = [selectionColumn];
    Object.keys(data).map(function (key) {
        var formatterType = data[key].formatterType;
        var isNumeric = formatterType === 'number' ||
            (typeof data[key].value === 'number' && formatterType !== 'string');
        header.push({
            id: key,
            type: 'value',
            Header: ValueColumnHeader,
            Cell: ValueCell,
            accessor: function (d) { return d[key]; },
            align: isNumeric ? 'right' : 'left',
        });
    });
    return header;
};
